<template>
  <div>
        <v-data-table
          :hide-default-header="hideHeader"	
          hide-default-footer	
          :headers="headers"
          :items="device.applications"
          sort-by="key"
          class="elevation-1"          
        >
          <template v-slot:[`item.name`]="{ item }">
            <router-link
              :to="{
                name: 'applicationDetails',
                params: {
                  project: item.projectId,
                  namespace: item.namespaceId,
                  application: item.id,
                },
              }"
              >{{ item.name }}</router-link
            >
          </template>
          <template v-slot:[`item.containers`]="{ item }">
            <div class="mt-3">
              <template v-for="(container, i) in item.spec.containers">
                <container-status                
                  :key="i"
                  :application="item"
                  :device="device"
                  :containers="item.spec.containers"
                  :applicationStatus="getContainerStatus(item, container.name)"
                ></container-status>
              </template>
            </div>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-tooltip            
              bottom
              :key="`${item.applicationId}-${item.id}`"
            >
              <template v-slot:activator="{ on: tooltip }">
              <span class="mr-2" v-on="{ ...tooltip }">
                <v-icon
                  v-if="
                    item.deploymentStatus.available == item.deploymentStatus.total
                  "
                  color="green accent-3"
                  >check_circle_outline</v-icon
                >
                <v-icon v-else color="error">error_outline</v-icon>
              </span>
            </template>
          
            <span v-if="item.deploymentStatus.status && item.deploymentStatus.status.lastSeen">
              Last reported: {{ item.deploymentStatus.status.lastSeen | date }}
            </span>
            <span v-else>
              Waiting for deployment status to be reported by device
            </span>
          </v-tooltip>
          </template>

          <template v-slot:[`item.allocation`]="{ item }">
            <router-link
              :to="{
                name: 'applicationAllocations',
                params: {
                  project: item.projectId,
                  namespace: item.namespaceId,
                  application: item.id,
                },
              }"
            >
              {{ item.deploymentStatus.available }}/{{
                item.deploymentStatus.total
              }}
            </router-link>
          </template>

          <template v-slot:item.actions="{ item }">
            <ApplicationLogsDialog :device="device" :application="item" ></ApplicationLogsDialog>
            <!-- <v-btn
                class="mr-2"
                x-small
                outlined
                :to="{
                  name: 'applicationLogs',
                  params: {
                    project: item.projectId,
                    namespace: item.namespaceId,
                    application: item.id,
                    device: device.id,
                  },
                }"
                router
              >
                LOGS
              </v-btn>                       -->
          </template>
          <template v-slot:no-data
            >No applications running on this device</template
          >
        </v-data-table>

  </div>
</template>

<script>
// import ProxyPort from '../cli/ProxyPort.vue';
import ContainerStatus from './ContainerStatus.vue';
import ApplicationLogsDialog from '../applications/ApplicationLogsDialog.vue';
export default {
  components: {
    // ProxyPort,
    ApplicationLogsDialog,
    ContainerStatus
  },
  props: {
    device: Object,
    hideHeader: Boolean
  },
  data() {
    return {
      headers: [
        {
          text: 'Name',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        { text: 'Containers', value: 'containers' },
        // { text: 'Allocation', value: 'allocation' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', align: 'right', sortable: false },
      ]
    }
  },
  computed: {
    
  },
  methods: {
    getContainerStatus(application, name) {

      // Get deploymentStatus for the container
      let containerStatus = application.deploymentStatus.status?.applicationStatuses?.find(
        (container) => container.name === name
      )
      return containerStatus
    },
    containerUrl(port) {
      
      if (!port.includes(":")) {
        if (port === "443" || port === "8443") {
          return `https://${this.device.info.ipAddress}:${port}`
        }
        return `http://${this.device.info.ipAddress}:${port}` 
      }
      let hostPort = port.split(":")[0]

      if (hostPort === "443" || hostPort === "8443") {
        return `https://${this.device.info.ipAddress}:${hostPort}`
      }
      return `http://${this.device.info.ipAddress}:${hostPort}` 

      // Splitting and getting the first entry
      // if (container.por)
    }
  }
}
</script>

<style>
</style>